(() => {
  if (window.cardSizeQuickaddReady) return;
  window.cardSizeQuickaddReady = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-card-size-quickadd] [data-variant-id]');
    if (!button || event.defaultPrevented) return;
    event.preventDefault();
    event.stopPropagation();
    const card = button.closest('[data-card-size-quickadd]');
    if (button.disabled || !button.dataset.variantId || card.getAttribute('aria-busy') === 'true') return;
    const status = card.querySelector('[role="status"]');
    card.setAttribute('aria-busy', 'true');
    status.textContent = '';
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.variantId, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this size.');
      document.dispatchEvent(new CustomEvent('card-size-quickadd:added', { detail: { items: result.items } }));
      // Archetype's native add event rebuilds and opens its cart drawer.
      // Do not wait for cart:updated: some versions do not emit it on rebuild.
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: result.items[0], addToCartBtn: button }
      }));
    } catch (error) {
      status.textContent = error.message || 'Unable to add this size. Please try again.';
    } finally {
      card.removeAttribute('aria-busy');
    }
  });
})();
